import React, { useState } from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { toast } from "react-hot-toast";
import {
  NEWSLETTER_STORAGE_KEY,
  SUPPORT_EMAIL,
} from "../../config/publicSite";

function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function FooterNewsletter() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!isValidEmail(trimmed)) {
      toast.error("Enter a valid email address");
      return;
    }

    setIsSubmitting(true);
    try {
      const existing = JSON.parse(
        localStorage.getItem(NEWSLETTER_STORAGE_KEY) ?? "[]"
      ) as string[];
      if (!existing.includes(trimmed)) {
        localStorage.setItem(
          NEWSLETTER_STORAGE_KEY,
          JSON.stringify([...existing, trimmed])
        );
      }
      toast.success("You're on the list — we'll ping you before the next drop.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Email us at " + SUPPORT_EMAIL);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-purple-700/90">
        Drop alerts
      </p>
      <p className="mt-2 text-sm font-semibold text-slate-900">
        Never miss a release
      </p>
      <form onSubmit={handleSubmit} className="mt-3 flex gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
          aria-label="Email for drop alerts"
          className="min-w-0 flex-1 rounded-xl border-0 bg-slate-100/80 px-3.5 py-2.5 text-sm text-slate-900 placeholder-slate-400 ring-1 ring-slate-200/80 transition focus:bg-white focus:outline-none focus:ring-2 focus:ring-purple-300/60"
        />
        <button
          type="submit"
          disabled={isSubmitting}
          className="inline-flex shrink-0 items-center justify-center rounded-xl bg-slate-900 px-3.5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#3B3B98] disabled:opacity-70"
          aria-label="Subscribe to drop alerts"
        >
          {isSubmitting ? (
            "…"
          ) : (
            <ArrowRightIcon className="h-4 w-4" aria-hidden />
          )}
        </button>
      </form>
    </div>
  );
}
